import {httpRequest} from "@/providers/http";
import {adaptLotteryGames} from "./lottery.adapter";
import type {LotteryGame, LotteryGamesApiResponse} from "./lottery.types";

export const getLotteryGamesService = async (): Promise<LotteryGame[]> => {
  const response = await httpRequest<LotteryGamesApiResponse>({
    method: "GET",
    url: "/lottery/games",
  });
  return adaptLotteryGames(response);
};
